
    import { css } from 'lit-element';
    export default css`:host{--margin:var(--kat-selection-card-group-margin,var(--kat-space-05))}:host ::slotted(kat-selection-card),:host kat-selection-card{margin:var(--margin)}`;
  